import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

export const CustomPagination = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 1rem;

  @media ${queries.less.sm} {
    width: 100%;
    justify-content: center;
  }

  button {
    height: 2.5rem;
    width: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    border: none;
    background-color: #ededed;
    border-radius: 999999px;
    aspect-ratio: 1/1;

    &:hover {
      background-color: #b3b1b1;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: none;
    }

    &[data-active='true'] {
      background-color: #6f64f8;
      color: #fff;
    }

    &:disabled {
      background-color: #f7fafc;
      cursor: not-allowed;
    }
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ededed;
    border-radius: 999999px;
  }
`

const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  align-self: stretch;

  @media ${queries.less.sm} {
    flex-direction: column;
    gap: 1.5rem;
    margin-bottom: 4.5rem;
  }

  .dropdown-toggle {
    border: 1px solid #c4c4c4;
    background-color: #fff !important;
    color: #2c2c2c;

    &:focus {
      color: #2c2c2c !important;
    }

    &:focus-visible {
      color: #2c2c2c !important;
    }

    &:hover {
      color: #2c2c2c !important;
    }
  }

  .dropdown-item {
    width: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

const Styles = {
  CustomPagination,
  PaginationWrapper,
}
export default Styles
